export const SAVE_LOGIN_INFO = "SAVE_LOGIN_INFO";
export const SAVE_DPO_CONFIG_ID = "SAVE_DPO_CONFIG_ID";
export const SAVE_SYSTEM_CONFIG_CONFIG_ID = "SAVE_SYSTEM_CONFIG_CONFIG_ID";
export const SAVE_DATA_PROCESSOR_ID = "SAVE_DATA_PROCESSOR_ID";
export const SAVE_PURPOSE_ID = "SAVE_PURPOSE_ID";
export const SAVE_LOGIN_USER_PROFILE_DETAILS =
  "SAVE_LOGIN_USER_PROFILE_DETAILS";

export const SAVE_SIGNUP_INFO = "SAVE_SIGNUP_INFO";
export const SAVE_ONBOARD_INFO = "SAVE_ONBOARD_INFO";
export const SAVE_USER_PROFILE = "SAVE_USER_PROFILE";
export const CLEAR_SESSION = "CLEAR_SESSION";
export const SAVE_TEMPLATES = "SAVE_TEMPLATES";
export const FETCH_BUSINESS_SUCCESS = "FETCH_BUSINESS_SUCCESS";
export const SAVE_CONSENT_DETAILS = "SAVE_CONSENT_DETAILS";
export const SET_TRANSLATIONS = "SET_TRANSLATIONS";
export const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";

export const SAVE_BUSINESSES = "SAVE_BUSINESSES";
export const SET_SELECTED_BUSINESS = "SET_SELECTED_BUSINESS";
export const UPDATE_BUSINESS_ID = "UPDATE_BUSINESS_ID";
export const SAVE_COMPANY_LOGO = "SAVE_COMPANY_LOGO";
export const SAVE_MULTILINGUAL_CONFIG = "SAVE_MULTILINGUAL_CONFIG";

